// Admin-only statistics and platform usage loaders.
import { SUPABASE_KEY, SUPABASE_URL } from "../config.js";
import { fetchAllRPC, readApiResponse, readableError } from "../lib/api.js";
import { showToast } from "../lib/dom.js";
import { state } from "../state.js";
import { supabase } from "../supabase-client.js";

export async function loadAdminStatistics() {
  const [
    { data: dashboard, error: dashboardError },
    { data: summary, error: summaryError },
    { data: usage, error: usageError },
    { data: daily, error: dailyError },
    { data: hourlyConnections, error: hourlyError },
    { data: users, error: usersError },
    { data: betaRequests, error: betaRequestsError },
    { data: platformCosts, error: platformCostsError },
    { data: tokenReviews, error: tokenReviewsError },
    exercisesResult
  ] = await Promise.all([
    supabase.rpc("get_admin_dashboard_summary"),
    supabase.rpc("get_admin_ai_summary"),
    supabase.rpc("list_admin_ai_usage", { selected_limit: 200 }),
    supabase.rpc("list_admin_ai_daily_usage", { selected_days: 30 }),
    supabase.rpc("list_admin_hourly_connections", { selected_days: 7 }),
    supabase.rpc("list_admin_users", { selected_limit: 500 }),
    supabase.rpc("list_admin_beta_access_requests", { selected_limit: 250 }),
    supabase.rpc("list_admin_platform_costs", { selected_limit: 200 }),
    supabase.rpc("list_admin_token_review_items", { selected_limit: 100 }),
    fetchAllRPC("list_admin_exercises", { selected_language: state.language, selected_limit: 5000 })
  ]);
  const error = dashboardError || summaryError || usageError || dailyError || hourlyError || usersError || betaRequestsError || platformCostsError || tokenReviewsError || exercisesResult.error;
  if (error) {
    showToast(error.message);
    return;
  }
  state.adminDashboard = dashboard?.[0] || null;
  state.adminSummary = summary?.[0] || null;
  state.adminUsage = usage || [];
  state.adminDailyUsage = daily || [];
  state.adminHourlyConnections = hourlyConnections || [];
  state.adminUsers = users || [];
  state.adminBetaRequests = betaRequests || [];
  state.adminBetaRefreshedAt = new Date();
  state.adminPlatformCosts = platformCosts || [];
  state.adminTokenReviews = tokenReviews || [];
  state.adminExercises = exercisesResult.data || [];
  state.adminSupabaseUsage = await loadSupabaseUsageSnapshot();
}

export async function loadAdminBetaRequests() {
  const { data, error } = await supabase.rpc("list_admin_beta_access_requests", { selected_limit: 250 });
  if (error) throw error;
  state.adminBetaRequests = data || [];
  state.adminBetaRefreshedAt = new Date();
}

export async function loadSupabaseUsageSnapshot() {
  try {
    const { data: sessionData } = await supabase.auth.getSession();
    const response = await fetch(`${SUPABASE_URL}/functions/v1/admin-supabase-usage`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        apikey: SUPABASE_KEY,
        Authorization: `Bearer ${sessionData.session.access_token}`
      },
      body: JSON.stringify({})
    });
    return await readApiResponse(response, "Unable to load Supabase usage.");
  } catch (error) {
    return {
      configured: false,
      message: readableError(error, "Unable to load Supabase usage.")
    };
  }
}
